import React from "react";
import { Descriptions, Badge } from "antd";
import { useSelector } from "react-redux";

const Fact_Info = ({inputData}) => {
  const lang_choiced = useSelector((state) => state.lang_change);
  const data = inputData
  return (
    <div>
      <Descriptions title=""  bordered>
        <Descriptions.Item label={lang_choiced.pages.add_fact.step1.forms.fact_name} span={2}>
          {data.fact_name}
        </Descriptions.Item>
        <Descriptions.Item label={lang_choiced.pages.add_fact.step1.forms.fact_address} span={2}>
          {data.fact_address}
        </Descriptions.Item>
        <Descriptions.Item label={lang_choiced.pages.add_fact.step1.forms.fact_tel} span={2}>
          {data.fact_tel}
        </Descriptions.Item>
        <Descriptions.Item label={lang_choiced.pages.add_fact.step1.forms.fact_post_code} span={2}>
          {data.fact_post_code}
        </Descriptions.Item>
        <Descriptions.Item label={lang_choiced.pages.add_fact.step1.forms.fact_country} span={2}>
          {data.fact_country}
        </Descriptions.Item>
        <Descriptions.Item label={lang_choiced.pages.add_fact.step1.forms.fact_state} span={2}>
          {data.fact_state}
        </Descriptions.Item>
        <Descriptions.Item label={lang_choiced.pages.add_fact.step1.forms.fact_city} span={2}>
          {data.fact_city}
        </Descriptions.Item>
        <Descriptions.Item label={lang_choiced.pages.add_fact.step1.forms.fact_power_name} span={2}>
          {data.fact_power_name}{""}{data.power}
        </Descriptions.Item>
        <Descriptions.Item label={lang_choiced.pages.add_fact.step1.forms.fact_timezone} span={2}>
          {data.fact_timezone}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default Fact_Info;
